const studies = {
  etp1: {
    domain: 'https://etp-experiment-1.dummytracker.org',
    page: '/cookie_access_test.html',
  },
  etp2: {
    domain: 'https://etp-experiment-2.dummytracker.org',
    page: '/cookie_access_test.html',
  },
}

const getEtpValue = () => {
  const maxWait = 4 * 1000;
  const timeoutEtpCalculation = new Promise(function(resolve) {
    setTimeout(() => resolve('etp-study-timed-out'), maxWait);
  }); // don't delay programmatic ads more than 5 seconds
  const calculateEtpValue = new Promise((resolve) => {
    const {etp1, etp2} = studies;

    let etp1PromiseDeferred;
    let etp1Promise = new Promise(function (resolve, reject) {
      etp1PromiseDeferred = {resolve: resolve, reject: reject};
    });

    let etp2PromiseDeferred;
    let etp2Promise = new Promise(function (resolve, reject) {
      etp2PromiseDeferred = {resolve: resolve, reject: reject};
    });

    function receiveMessage(event) {
      if (event.origin === etp1.domain) {
        etp1Promise = etp1PromiseDeferred.resolve(cookiesBlocked(event.data));
      } else if (event.origin === etp2.domain) {
        etp2Promise = etp2PromiseDeferred.resolve(cookiesBlocked(event.data));
      }
    }

    /**
     * Returns true if cookies are blocked
     * @param data
     * @returns {boolean}
     */
    function cookiesBlocked(data) {
      return data === 'no_cookies';
    }

    Promise.all([etp1Promise, etp2Promise]).then(function (values) {
      const [isEtp1Blocked, isEtp2Blocked] = values;

      let etpLevel;
      if (isEtp1Blocked && !isEtp2Blocked) {
        etpLevel = 'etp-level-2';
      } else if (!isEtp1Blocked && isEtp2Blocked) {
        etpLevel = 'etp-level-1';
      } else {
        etpLevel = 'not-in-study';
      }

      resolve(etpLevel);
    });

    window.addEventListener("message", receiveMessage, false);

    const testOrigin = document.location.hostname;

    var etp1Frame = document.createElement('iframe');
    etp1Frame.setAttribute('id', 'etp1Frame');
    etp1Frame.setAttribute('style', 'display: none; width:0; height:0; border:0; border:none;');
    document.body.appendChild(etp1Frame);
    etp1Frame.setAttribute('src', `${etp1.domain}${etp1.page}?test_origin=${testOrigin}`);

    var etp2Frame = document.createElement('iframe');
    etp2Frame.setAttribute('id', 'etp2Frame');
    etp2Frame.setAttribute('style', 'display: none; width:0; height:0; border:0; border:none;');
    document.body.appendChild( etp2Frame);
    etp2Frame.setAttribute('src', `${etp2.domain}${etp2.page}?test_origin=${testOrigin}`);
  });

  return Promise.race([calculateEtpValue, timeoutEtpCalculation]);
}

const gtagPromise = new Promise((success) => {
  googletag.cmd.push(success);
})

const domLoadedPromise = new Promise((success) => {
  window.addEventListener("DOMContentLoaded", success)
})

const loadAd = (slotId) => {
  googletag.display(slotId);
  if (typeof (pubwise) != 'undefined' && pubwise.enabled === true) {
    pwpbjs.que.push(function () {
      pwRegisterLazyLoad(gptadslots[slotId], 2, [50, 0, 50, 0], 0, 768, 2);
    });
  } else {
    googletag.pubads().refresh([gptadslots[slotId]]);
  }
}

const loadAds = (ids) => {
  ids.forEach(slotId => loadAd(slotId))
}

const loadSyndicatedAds = () => {
  return domLoadedPromise.then(() => {
    const adContainers = Array.from(document.querySelectorAll('div.syndication-ad-to-load')).reduce((adIds, ad) => {
      return [...adIds, ad.id];
    }, []);
    loadAds(adContainers)
  })
}

export default () => {
  getEtpValue()
  .then(etpValue => gtagPromise.then(() => etpValue)) // ensure googletag is ready
  .then(etpValue => window.setAdConfig(etpValue))
  .then(() => loadSyndicatedAds());
}
